import background from 'assets/img/research/logistics-bg.jpg'
import { Fragment } from 'react'

export const logistics = {
  background: background,
  title: 'Logistics',
  logisticsList: [
    {
      subTitle: 'Grades',
      desc: 'Incoming 9th-12th graders + college freshmen',
    },
    {
      subTitle: 'Dates & Time',
      desc:
        <Fragment>
          July 7 - Aug 8, 2025
          <span className="d-block">Monday - Friday</span>
          <span className="d-block">12 - 4pm ET (9am - 1pm PT)</span>
          <small className="d-block">*Must be able to join live sessions</small>
        </Fragment>
      ,
    },
    {
      subTitle: 'Location',
      desc: (
        <Fragment>
          <span className="d-block mb-5">Virtual, with live instruction</span>
          <small className="d-block">
            Special events such as campus or facility tours, community events,
            and speaker panels may periodically take place virtually or
            in-person depending on a student’s regional hub.
          </small>
        </Fragment>
      ),
    },
    {
      subTitle: 'Prerequisites',
      desc: 'No prior STEM experience required; students will learn all skills required during the program.',
    },
    {
      subTitle: 'Eligibility',
      desc: <Fragment>
        <span className="d-block mb-5">Oceanside Scholars Program is open to students in the Oceanside, California area</span>
      </Fragment>,
    },
    {
      subTitle: 'Tuition',
      desc: (
        <Fragment>
          <span className='d-block mb-5'><span className='text-gold fs-18'>Free</span>, for all accepted students</span>
          <small className="d-block">
            Oceanside Scholars Research Program is fully funded, thanks to the Oceanside Community Foundation, the U.S. Department of War (DoW) STEM and the Defense STEM Education Consortium (DSEC).
          </small>
        </Fragment>
      ),
    },
  ],
}
